export type Role =
  | 'groupLeader'
  | 'groupOperator'
  | 'regionManager'
  | 'campusManager'
  | 'researchLead'
  | 'studentService'
  | 'teacher'
  | 'reviewer'
  | 'deviceManager'
  | 'systemAdmin'
  | 'support';
export const roles: Record<Role, string> = {
  groupLeader: '集团领导',
  groupOperator: '集团业务管理员',
  regionManager: '区域负责人',
  campusManager: '校区负责人',
  researchLead: '教研负责人',
  studentService: '学管／服务人员',
  teacher: '教师',
  reviewer: '沟通核查人员',
  deviceManager: '设备管理员',
  systemAdmin: '系统管理员',
  support: '服务支持人员',
};
export type Kind =
  | 'device'
  | 'binding'
  | 'batch'
  | 'recording'
  | 'job'
  | 'clue'
  | 'case'
  | 'task'
  | 'message'
  | 'audit'
  | 'model'
  | 'station'
  | 'repair'
  | 'inventory'
  | 'template'
  | 'correction'
  | 'plan'
  | 'lesson'
  | 'teacher'
  | 'student'
  | 'followUp'
  | 'feedback'
  | 'knowledge'
  | 'pilot'
  | 'ticket'
  | 'rule'
  | 'integration'
  | 'help'
  | 'zone'
  | 'organization'
  | 'policy'
  | 'modelConfig'
  | 'subscription'
  | 'evaluation'
  | 'position';
export interface Segment {
  uuid: string;
  startMs: number;
  endMs: number;
  speaker: string;
  text: string;
}
export interface Transcript {
  uuid: string;
  createdAt: string;
  segments: Segment[];
}
export interface Evidence {
  recordingUuid: string;
  transcriptVersionUuid: string;
  startMs: number;
  endMs: number;
  quote: string;
}
export interface Entity {
  uuid: string;
  kind: Kind;
  title: string;
  campus: string;
  memberUuid: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  revision: number;
  note: string;
  deviceUuid?: string;
  sourceUuid?: string;
  owner?: string;
  dueAt?: string;
  startAt?: string;
  endAt?: string;
  result?: string;
  evidence?: Evidence;
  versions?: Transcript[];
  fixture?: number;
  progress?: number;
  stage?: string;
  failOnce?: boolean;
  failedBefore?: boolean;
  received?: boolean;
  hash?: string;
  supportsRemote?: boolean;
  reportedAt?: string;
  battery?: number;
  model?: string;
  conclusion?: string;
  generation?: number;
  fields?: Record<string, string>;
  audioBlob?: Blob;
}
export interface Context {
  role: Role;
  campus: string;
  viewMemberUuid: string;
}
export interface Snapshot {
  version: number;
  revision: number;
  now: string;
  context: Context;
  entities: Entity[];
  receipts: Record<string, string>;
  drafts: Record<string, string>;
  domainVersions?: Record<string, number>;
  domainData?: Record<string, import('./contracts').JsonObject>;
}
export interface SessionIdentity {
  appId: string;
  tenantUuid: string;
  memberUuid: string;
}
export const campuses = ['第一校区', '第二校区', '第三校区'];
export const teacherNames = [
  '林老师',
  '周老师',
  '陈老师',
  '吴老师',
  '赵老师',
  '李老师',
  '王老师',
  '孙老师',
  '郑老师',
  '何老师',
  '许老师',
  '徐老师',
];
export const teachers = teacherNames.map((_, i) => seedUuid(50000 + i));
export const teacherName = (memberUuid: string) =>
  teacherNames[teachers.indexOf(memberUuid)] || memberUuid;
export const teacherOptions = teachers.map((value) => ({
  value,
  label: teacherName(value),
}));
export const statusLabels: Record<string, string> = {
  stock: '在库',
  assigned: '已领用',
  repair: '维修中',
  disabled: '停用',
  retired: '报废',
  pending: '待开始',
  connecting: '连接中',
  transferring: '传输中',
  confirming: '待后台确认',
  completed: '已完成',
  failed: '失败',
  paused: '暂停',
  cancelled: '已取消',
  ready: '已就绪',
  processing: '处理中',
  queued: '排队',
  running: '执行中',
  succeeded: '成功',
  unassigned: '待分派',
  pendingReview: '待复核',
  needsInfo: '待补充',
  confirmed: '已确认',
  excluded: '已排除',
  closed: '已关闭',
  inProgress: '处理中',
  pendingAcceptance: '待验收',
  reopened: '重新打开',
  draft: '草稿',
  pendingApproval: '待审核',
  published: '已发布',
  returned: '退回修改',
  withdrawn: '已撤回',
  approved: '已批准',
  sentSimulated: '模拟已发送',
  unread: '未读',
  read: '已读',
  active: '有效',
  accepted: '已接受',
  rejected: '已驳回',
};
export const label = (status: string) => statusLabels[status] || status;
export function seedUuid(index: number) {
  return `10000000-0000-4000-8000-${String(index).padStart(12, '0')}`;
}
